/**
 * Filter storage keys that should be cleared on logout
 * These keys contain user-specific filter preferences
 */
const FILTER_KEYS = {
  JOB_CANDIDATES_FILTERS: 'kula_filters_job_details_candidates',
  ATS_JOBS_FILTERS: 'kula_filters_jobs_list',
  CONTACTS_FILTERS: 'kula_filters_contacts_list',
  REQUISITIONS_FILTERS: 'kula_filters_requisitions',
  REPORTS_FILTERS: 'kula_filters_reports',
  CUSTOM_REPORTS_FILTERS: 'kula_filters_custom_reports',
  STATIC_REPORTS_FILTERS: 'kula_filters_static_reports',
  JOB_REFERRALS_FILTERS: 'kula_filters_job_referrals',
  REFERRED_CANDIDATES_FILTERS: 'kula_filters_referred_candidates',
  ATS_JOBS_LIST_APPLIED: 'kula_job_list_filters_applied',
  INTERVIEWS_FILTERS: 'kula_filters_interviews_list',
  INTERNAL_JOBS_FILTERS: 'kula_filters_internal_jobs',
  INTERNAL_APPLICATIONS_FILTERS: 'kula_filters_internal_applications',
};

export const AI_SEARCH_STORAGE_KEYS = {
  RECENT_SEARCH_QUERIES: 'kula_ai_search_recent_queries',
  RECENT_VIEWED_CANDIDATES: 'kula_ai_search_recent_viewed_candidates',
};

/**
 * Common storage keys used across the application
 */
export const STORAGE_KEYS = {
  ...FILTER_KEYS,

  PREVIOUS_LOCATION_PATHNAME: 'kula_previous_location_pathname',

  // The settings pages a user opened most recently, shown as chips on
  // Settings > Home. Server-backed via /user_preference so it follows the user
  // between devices.
  SETTINGS_RECENT_PAGES: 'kula_settings_recent_pages',

  // Announcement banners this user has closed, by id. Server-backed for the
  // same reason as the pages above: dismissing on a laptop should stick on a
  // phone.
  SETTINGS_DISMISSED_BANNERS: 'kula_settings_dismissed_banners',

  // Generators (dynamic keys)
  getJobPipelineAppReviewSortKey: (jobId, stageId) =>
    jobId && stageId
      ? `kula_job_${jobId}_stage_${stageId}_pipeline_appReviewSort`
      : undefined,
  getJobPipelineGlobalSortKey: (jobId) =>
    jobId ? `kula_job_${jobId}_pipeline_globalSort` : undefined,
  getReportFiltersKey: (reportId) =>
    reportId ? `kula_filters_report_${reportId}` : undefined,

  // TODO: Add other storage keys here used across the app here
};

const PERSIST_ACROSS_LOGOUT_KEYS = ['is-nav-collapsed'];

/**
 * Clears all localStorage items
 * Should be called on user logout to prevent any state leaking between users
 * Preserves UI preference keys listed in PERSIST_ACROSS_LOGOUT_KEYS
 */
export const clearLocalStorage = () => {
  const preserved = {};
  PERSIST_ACROSS_LOGOUT_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) preserved[key] = value;
  });

  localStorage.clear();

  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
